// import { combineReducers } from 'redux';
// import user from './user_reducer';

// const rootReducer = combineReducers({
//     user,
// });

// export default rootReducer;
import { combineReducers } from 'redux';
import UserReducer from './user_reducer';
import NotificationReducer from './notification_reducer';

const rootReducer = combineReducers({
  user: UserReducer,
  notification: NotificationReducer,
});

export default rootReducer;
